import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const Box = props => {
  const {
    children,
    borderBox = true,
    className,
    id
  } = props;
  return (
    <div
      id={id}
      className={
        clsx('d-flex flex-column justify-content-center align-items-center flex-fill h-100 w-100',
          {'border-box': borderBox}, className)}
      style={{ minHeight: 'min-content' }}>
      {children}
    </div>
  );
};

Box.propTypes = {
  className: PropTypes.string
};

export default Box;
